import { T } from "@classdojo/web";
import { LabelText } from "@classdojo/web/nessie";
import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import ExperienceCard from "./ExperienceCard";
import { Board } from "src/pods/ideas/data/types";

const boardOrder = [
  "positive-thinking",
  "respect",
  "big-challenges",
  "moods-and-attitudes",
  "conundrums",
  "growth-mindset",
  "perseverance",
  "empathy",
  "mindfulness",
];

export type ExperiencesProps = {
  boards: Board[];
  mountPoint: string;
  classId: string;
  isLoadingBoards: boolean;
  loadBoards: VoidFunction;
};

export default function Experiences({ boards, mountPoint, classId, isLoadingBoards, loadBoards }: ExperiencesProps) {
  if (!boards.length && !isLoadingBoards) {
    loadBoards();
  }
  return (
    <div sx={{ marginTop: "dt_l" }}>
      <LabelText level={2} kind="secondary" sx={experiencesContainerH4Style} as="h4">
        <T str="dojo.toolkit:experiences.big_ideas" fallback="Big Ideas" />
      </LabelText>
      <div sx={experiencesCardsWrapperStyle}>
        {boardOrder.map((slug) => {
          const board = boards.find((b) => b.slug === slug);
          if (slug === "conundrums") {
            return (
              <ExperienceCard
                key={"conundrums"}
                mojo={"https://static.classdojo.com/img/ideas_platform/activities/conundrums/conundrums.png"}
                href={`/apps/remote/${mountPoint}/${classId}/conundrums`}
                title={"Conundrums"}
                description=""
              />
            );
          } else if (board) {
            return (
              <ExperienceCard
                key={board.slug}
                mojo={board.image}
                href={`/apps/remote/${mountPoint}/ideas/${board.slug}`}
                title={board.title}
                description=""
              />
            );
          }
        })}
      </div>
    </div>
  );
}

const experiencesCardsWrapperStyle: ThemeUIStyleObject = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "center",
};

const experiencesContainerH4Style: ThemeUIStyleObject = {
  textTransform: "uppercase",
  textAlign: "center",
  marginBottom: "dt_m",
};
